import { PoleasPublicAuthProvider } from '@/context/PoleasPublicAuthProvider'
import { Apps } from '@/dtos'
import { AppLayout } from './AppLayout'

export const PoleasBaseLayout = () => {
  return <PoleasPublicAuthProvider>
    <AppLayout app={Apps.publicPoleas} />
  </PoleasPublicAuthProvider>
}